// extracted by mini-css-extract-plugin
export default {"addNewRequestButton":"manage-requests_addNewRequestButton__5Gvty","mobileButton":"manage-requests_mobileButton__uYxnN"};